﻿angular.module('projectModule')
    .factory('InstallationOverigFactory',
        ['$log', 'ntaData', 'ntabuilding', 'ntaValidation', 'ntaEntityData', 'ntaSharedLogic', 'ListCache',
function ($log,   ntaData,   ntabuilding,   ntaValidation,   ntaEntityData,   ntaSharedLogic,   ListCache) {
    'use strict';

    //== Constantes die voor elke instantie hetzelfde zijn ========================================

    // Per installatietype, de entityId van de opwekker en de propertyId van het type van de opwekker.
    const _opwekkerPathAndPropId = new Map(Object.entries({
        INST_VERW: ['VERW.VERW-OPWEK', 'VERW-OPWEK_TYPE'],
        INST_TAPW: ['TAPW.TAPW-OPWEK', 'TAPW-OPWEK_TYPE'],
        INST_KOEL: ['KOEL.KOEL-OPWEK', 'KOEL-OPWEK_TYPE'],
    }));

    /// Alle opwekkertypes die CO₂-emissies veroorzaken (tbv [OV-AE]).
    const _co2Opwekkertypes = new Set([
        "VERW-OPWEK_TYPE_B",    // warmtepomp - gasmotor
        "VERW-OPWEK_TYPE_U",    // warmtepomp - gasabsorptie
        "VERW-OPWEK_TYPE_H",    // CV-ketel - gas
        "VERW-OPWEK_TYPE_J",    // kachel - gas
        "VERW-OPWEK_TYPE_K",    // kachel - olie
        "VERW-OPWEK_TYPE_L",    // centrale direct gestookte luchtverwarmer - gas
        "VERW-OPWEK_TYPE_N",    // lokale direct gestookte luchtverwarmer - gas
        "VERW-OPWEK_TYPE_O",    // WKK - micro
        "VERW-OPWEK_TYPE_P",    // WKK - overig
        "VERW-OPWEK_TYPE_Q",    // stoomketel - gas
        "VERW-OPWEK_TYPE_R",    // stoomketel - olie
        "VERW-OPWEK_TYPE_T",    // CV-ketel - olie

        "TAPW-OPWEK_TYPE_3",    // warmtepomp - gas
        "TAPW-OPWEK_TYPE_12",   // CV-ketel - gas
        "TAPW-OPWEK_TYPE_13",   // CV-ketel - olie
        "TAPW-OPWEK_TYPE_14",   // geiser - gas
        "TAPW-OPWEK_TYPE_15",   // gasboiler ≤ 150 kW
        "TAPW-OPWEK_TYPE_16",   // gasboiler > 150 kW
        "TAPW-OPWEK_TYPE_17",   // WKK
        "TAPW-OPWEK_TYPE_19",   // zonneboiler met geïntegreerde gasgestookte naverwarming

        "KOEL-OPWEK_TYPE_2",    // compressiekoeling - gas
        "KOEL-OPWEK_TYPE_8",    // absorptiekoeling - gas
        "KOEL-OPWEK_TYPE_10",   // absorptiekoeling - WKK
    ]);



    return function InstallationOverigLogic(ntaDependencyValidation) {
        const self = this;

        //== Imports ==============================================================================
        self.ntaValidation = ntaValidation;
        self.dependencyValidator = ntaDependencyValidation;

        //== Instance data ========================================================================

        const _entdataInstallatie = getOrCreateInstallatie();
        const _entdata = _entdataInstallatie && ntaEntityData.getFirstChild(_entdataInstallatie, 'OVERIG');
        const _listCache = new ListCache();

        //== Exports ==============================================================================
        self.entdataInstallatie = _entdataInstallatie;
        self.entdata = _entdata;
        self.properties = ntaData.properties[_entdata?.EntityId] ?? [];

        // al deze methods exporteren zodat ze publiek beschikbaar zijn
        Object.assign(self, {
            // standaard methods tbv validatie
            isHidden,
            isReadOnly,
            hasCodedValues,
            getCodedValues,
            getListItem,
            saveValue,
            validate,
            validateDependencies,
            startFormValidation,
            endFormValidation,
            setGeopend,
        });

        //== Initialization =======================================================================

        // (geen initialisatie nodig)


        //== Implementation =======================================================================

        function isReadOnly(prop, entdata = _entdata) {
            if (!prop)
                return true;

            switch (prop.Id) {
                case 'OVERIG_OPEN': {
                    return true;
                }
            }

            return false;
        } //-- end: isReadOnly --------------------------------------------------------------------


        function getOrCreateInstallatie(type = 'OVERIG') {
            const installatietype = `INST_${type}`;

            let entdataInst = ntaEntityData.getListWithEntityId('INSTALLATIE')
                .find(ed => ed.PropertyDatas['INSTALL_TYPE'].Value === installatietype);

            if (!entdataInst && ntaData.entities[type] && !ntaEntityData.getShadowId()) {

                let entdataSys = ntaEntityData.getFirstWithEntityId(type)
                    ?? ntaEntityData.get(ntaEntityData.create(type));

                const newId = ntaEntityData.create('INSTALLATIE', -1, [], [
                    { OnCopy: 1, OnDelete: 1, Child: entdataSys.EntityDataId },
                ], [
                    { PropertyId: 'INSTALL_TYPE', Value: installatietype },
                ]);
                entdataInst = ntaEntityData.get(newId);
            }
            return entdataInst;
        } //-- end: getOrCreateInstallatie --------------------------------------------

        function isHidden(prop, entdata = _entdata) {
            if (typeof prop === 'string') prop = ntaData.properties[prop];
            if (!prop || !entdata) {
                return true;
            }
            const propdata = entdata.PropertyDatas[prop.Id];
            if (!propdata) {
                return true;
            }

            let visible = true;
            let relevant = null; // null = zelfde als visible

            switch (prop.Id) {
                case 'OVERIG_OPEN': {
                    visible = false;
                    break;
                }
                case 'OVERIG_INST_GT290': { // OV03
                    visible = ntaSharedLogic.isUtiliteit();
                    break;
                }
                case 'OVERIG_INST_GT290_NON': { // OV03 non-editable
                    // dit veld is bedoeld om de waarde tbv de rekenkern te bepalen, en is dus nooit zichtbaar
                    visible = false;

                    const propEditable = ntaData.properties['OVERIG_INST_GT290'];
                    const propdataEditable = propEditable.getData(entdata);
                    relevant = propdataEditable.Visible;

                    if (relevant && !propdata.Value) {
                        // als dit veld relevant is maar nog leeg was, dan zorgen dat het gevuld wordt.
                        validateDependencies(propEditable, entdata); // [OV-AB]
                    }
                    break;
                }
                case 'OVERIG_GACS': { // OV04
                    visible = ntaSharedLogic.isUtiliteit() && conditionAC();
                    break;
                }
            }

            if (relevant === null) relevant = visible;
            ntaEntityData.setPropdataStatus(propdata, relevant, visible);
            return !visible;
        } //-- end: isHidden ----------------------------------------------------------------------

        function conditionAB() {
            // [OV-AB] als OV03=aanwezigheid installatie met vermogen > 290 kW onbekend reken met
            //  verwarmings- of koelinstallatie > 290 kW niet aanwezig als aangesloten Ag ≤ 2500.
            // Als aangesloten Ag groter dan 2500 m² reken met ‘verwarmings- of koel-
            //  installatie > 290 kW aanwezig’.
            // Bepaal voor elk verwarmings- of koelinstallatie het op de installatie aangesloten Ag:
            // - Indien het een individuele installatie betreft (KO07 = niet-gemeenschappelijke
            //   installatie 'installatie met individuele aflevering' / HO42 = niet-
            //   gemeenschappelijke installatie 'installatie met individuele aflevering' ) dan
            //   is het aangesloten Ag: ∑Ag;zi van de rekenzones aangesloten op de installaties
            //   + Ag van de gemeenschappelijke ruimtes aangesloten op de installatie
            // - indien het een gemeenschappelijke installatie betreft (KO07 = gemeenschappelijke
            //   installatie 'installatie met centrale aflevering' / HO42 = gemeenschappelijke
            //   installatie 'installatie met centrale aflevering' ) dan is het aangesloten Ag
            //   HO08 / KO08 + Ag van de gemeenschappelijke ruimtes aangesloten op de installatie.
            for (const install of ntaEntityData.getListWithEntityId('INSTALLATIE')) {
                const installatietype = install.PropertyDatas['INSTALL_TYPE'].Value;
                let pathToOpwekker, propIdCommon, valueCommon, propIdArea;
                switch (installatietype) {
                    case 'INST_VERW': {
                        pathToOpwekker = 'VERW.VERW-OPWEK';
                        propIdCommon = 'VERW-OPWEK_GEM';
                        valueCommon = 'VERW-OPWEK_GEM_WEL';
                        propIdArea = 'VERW-OPWEK_A';
                        break;
                    }
                    case 'INST_KOEL': {
                        pathToOpwekker = 'KOEL.KOEL-OPWEK';
                        propIdCommon = 'KOEL-OPWEK_GEM';
                        valueCommon = 'KOEL-OPWEK_GEM_WEL';
                        propIdArea = 'KOEL-OPWEK_A';
                        break;
                    }
                    default:
                        continue; // alleen verwarming of koeling
                }

                const systeem = ntaSharedLogic.systeem(install);
                let area = ntaSharedLogic.AgSumRZbySystem(systeem, true);

                const prefOpwekker = ntaEntityData.findEntity(install, pathToOpwekker);
                const isCommon = prefOpwekker.PropertyDatas[propIdCommon].Value === valueCommon;
                if (isCommon) {
                    const commonArea = area - ntaSharedLogic.AgSumRZbySystem(systeem, false);

                    const propdataArea = prefOpwekker.PropertyDatas[propIdArea];
                    const installationArea = ntaSharedLogic.parseFloat(propdataArea.Relevant && propdataArea.Value, 0);
                    area = installationArea + commonArea;
                }
                if (area > 2500) {
                    return true;
                }
            }
            return false;
        } //-- end: conditionAB -------------------------------------------------------------------

        function conditionAC() {
            // [OV-AC] toon als OV03 = :
            // - installatie met vermogen > 290 kW aanwezig OF
            // - aanwezigheid installatie met vermogen > 290 kW onbekend EN de waarde volgend uit conditie [OV-AB] is Ag > 2500 m2
            const instGT290 = _entdata.PropertyDatas['OVERIG_INST_GT290_NON'].Value;
            return instGT290 === 'OVERIG_INST_GT290_WEL';
        } //-- end: conditionA --------------------------------------------------------------------

        function conditionAE() {
            // [OV-AE] zet dit veld vast op 'installaties met CO₂-emissies aanwezig' als:
            // - bij 1 van de verwarmingsinstallaties in HO05 een opwekker is gekozen waarvan key2 van Table9_0 = gas/olie EN/OF
            // - bij 1 van de tapwatersystemen in TO05 is gekozen voor een opwekker met key3 van Table13_0 = gas/olie EN de opwekker≠onbekende gemeenschappelijke opwekker EN/OF
            // - bij 1 van de koelsystemen in KO05 de opwekker is compressiekoeling - gas / absorptiekoeling - gas / absorptiekoeling - WKK
            return ntaEntityData.getListWithEntityId('INSTALLATIE')
                .some(install => {
                    const [opwekkerPath, typePropId] = _opwekkerPathAndPropId.get(install.PropertyDatas['INSTALL_TYPE'].Value) ?? [];
                    return !!opwekkerPath
                        && ntaEntityData.findEntities(install, opwekkerPath)
                            .some(opwekker => _co2Opwekkertypes.has(opwekker.PropertyDatas[typePropId].Value));
                });
        } //-- end: conditionAE -------------------------------------------------------------------

        function hasCodedValues(prop) {
            return ntaValidation.hasCodedValues(prop);
        } //-- end: hasCodedValues ----------------------------------------------------------------

        function getCodedValues(prop, entdata = _entdata) {
            let codedValues = ntaValidation.codedValues(prop);
            switch (prop.Id) {
                case 'OVERIG_INST_CO2_EM': { // OV06
                    // [OV-AE] zet dit veld vast op 'installaties met CO₂-emissies aanwezig' als: ...
                    if (conditionAE()) {
                        codedValues = codedValues.filter(cv => cv.Id === 'OVERIG_CO2_EM_WEL');
                    }
                    break;
                }
            }

            ntaSharedLogic.checkPropdataInList(prop, entdata, codedValues, self);

            // Zorg dat we alleen een nieuwe lijst teruggeven als deze gewijzigde waardes heeft,
            //  anders denkt AngularJS steeds dat het om een compleet nieuwe lijst gaat, en triggert
            //  deze oneindige digests.
            return _listCache.useCacheIfUnchanged(prop.Id, codedValues, (a, b) => a.Id === b.Id && a.Value === b.Value);
        } //-- end: getCodedValues ----------------------------------------------------------------

        function getListItem(prop, entdata = _entdata, list = null) {
            let listItem = null;

            if (entdata && prop?.Domain?.DomainType > 1) {
                const propValue = prop.getValue(entdata);
                let itemId = propValue;
                if (!list) {
                    //-- anders ongefilterde codedValue list gebruiken
                    list = prop.Domain.Codes;
                }
                if (list && list.length > 0) {
                    listItem = list.find(item => item.Id === itemId);
                }
            }

            return listItem;
        } //-- end: getListItem ------------------------------------------------------------------

        function saveValue(propOrId, entdata, newValue) {
            const prop = typeof propOrId === 'string' ? ntaData.properties[propOrId] : propOrId;

            if (!prop) {
                return false;
            }

            let result = ntaSharedLogic.saveValue(prop, entdata, newValue, self, ntaEntityData);

            const value = prop.getValue(entdata);
            switch (prop && prop.Id) {
            }

            return result;
        } //-- end: saveValue ---------------------------------------------------------------------

        function validate(prop, propdata) {
            if (!ntabuilding.canSave()) return;
            if (!prop || !propdata || propdata.BuildingId !== ntabuilding.buildingId) {
                return;
            }

            const hidden = isHidden(prop);
            const readOnly = isReadOnly(prop);

            if (hasCodedValues(prop)) {
                getCodedValues(prop);
            }

            let valid = ntaValidation.IsValid(self.form, prop, propdata, hidden, readOnly);

            switch (prop.Id) {
            }

            return valid;
        } //-- end: validate ---------------------------------------------------------------------

        function validateDependencies(prop, entdata) {
            if (!prop || !entdata) {
                return;
            }

            const propdata = prop.getData(entdata);
            const checkValue = propdata.Value;

            let performDefaultChecks = true;

            switch (prop.Id) {
                case 'OVERIG_INST_GT290': { // OV03
                    let calcValue = propdata.Value;
                    if (calcValue === 'OVERIG_INST_GT290_ONB') { // [OV-AC]
                        calcValue = conditionAB() ? 'OVERIG_INST_GT290_WEL' : 'OVERIG_INST_GT290_NIET';
                    }
                    saveValue('OVERIG_INST_GT290_NON', entdata, calcValue);
                    performDefaultChecks = false;
                    break;
                }
            }

            if (performDefaultChecks) {
                isHidden(prop, entdata);
                if (ntaValidation.hasCodedValues(prop)) {
                    getCodedValues(prop);
                }
                if (propdata.Value !== checkValue) {
                    saveValue(prop, entdata);
                }
            }
        } //-- end: validateDependencies ----------------------------------------------------------

        function startFormValidation() {
            return ntaSharedLogic.startFormValidation(getAllEntDatas(), self);
        } //-- end: startFormValidation -----------------------------------------------------------

        function endFormValidation() {
            return ntaSharedLogic.endFormValidation(getAllEntDatas(), self);
        } //-- end: endFormValidation -------------------------------------------------------------

        function getAllEntDatas() {
            return [_entdata]
                .filter(ed => ed);
        } //-- end: getAllEntDatas ----------------------------------------------------------------

        function setGeopend() {
            const propdataOpen = _entdata.PropertyDatas['OVERIG_OPEN'];
            ntaEntityData.saveprop(propdataOpen, 'true');
        } //-- end: setGeopend --------------------------------------------------------------------

    };
}]);
